<template>
	<ElementButton
		name="download"
		i18n
		:content="content"
		:state="partState"
		@click.stop="onClick"
		data-url="command://noOp"
	/>
</template>

<script>
import { mapActions } from 'vuex';

import { syncActionStates } from '@/tools/consts';
import { actionTypes } from '@/types';
import { mapStateNested } from '@/tools/helpers';

export default {
	props: {
		subPartId: String,
	},
	computed: {
		...mapStateNested('packageSyncer', ['subPartStates']),
		...mapStateNested('dataSourceCFG.global', ['isProgressiveWebApp']),
		content() {
			if (this.partState === syncActionStates.loadIncomplete) return 'update';
			else if (this.partState === syncActionStates.loading) return 'downloading';
			else if (this.partState === syncActionStates.loaded) return 'delete';
			else if (this.partState === syncActionStates.deleting) return 'deleting';
			else if (
				this.partState === syncActionStates.loadPending ||
				this.subPartStates[this.subPartId] === syncActionStates.deletePending
			)
				return 'waiting';
			return 'download';
		},
		partState() {
			return this.subPartStates[this.subPartId];
		},
	},
	methods: {
		...mapActions([
			actionTypes.packageSyncerLoad,
			actionTypes.packageSyncerDelete,
			actionTypes.progressiveWebAppLoad,
			actionTypes.progressiveWebAppDelete,
		]),
		onClick() {
			this.subPartId;
			const syncerType = this.isProgressiveWebApp ? 'progressiveWebApp' : 'packageSyncer';
			if (this.partState !== syncActionStates.loaded) {
				this[`${syncerType}Load`]({ subPartId: this.subPartId });
				return;
			}
			if (this.partState === syncActionStates.loaded) {
				this[`${syncerType}Delete`]({ subPartId: this.subPartId });
				return;
			}
		},
	},
	watch: {
		partState(newState) {
			this.$el.parentNode.setAttribute('sub-part-state', newState);
		},
	},
	mounted() {
		if (this.$el.parentNode) {
			this.$el.parentNode.setAttribute('sub-part-state', this.partState);
		}
	},
};
</script>

<style lang="scss"></style>
